import { HubItemCategoryModel } from "client/Api/Hub/hub";
import { HubDetailsLayoutTitleKind } from "../HubDetailsLayout";

export type ContentTitleKind =
	| "regular"
	| "placeholder";

export type ContentTitle =
	| string
	| {
		kind: ContentTitleKind;
		value: string;
	};

export type HubItemNameOnlyCategory = {
	name: string;
};

export function resolveTitle(title: ContentTitle): string {
	return typeof title === "string"
		? title
		: title.value;
}

export function resolveTitleKind(title: ContentTitle): HubDetailsLayoutTitleKind {
	return typeof title === "string"
		? "primary"
		: titleKindMap[title.kind];
}

export function isFullCategoryModel(category: HubItemNameOnlyCategory | HubItemCategoryModel): category is HubItemCategoryModel {
	return typeof (category as HubItemCategoryModel).id === "number";
}

const titleKindMap: {[kind in ContentTitleKind]: HubDetailsLayoutTitleKind;} = {
	"regular": "primary",
	"placeholder": "secondary"
};

